import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {Banner, Label} from '../components';
import { Button, notify } from 'app/components'
import { Calendar, MoneyWavy, Plus } from '@phosphor-icons/react';
import Faq from './faq';
import PayoutModal from './payoutModal';
import CantEdit from './cantEdit';
import { useSelector } from 'react-redux';
import { getBusinessConfig, updateBusinessConfig } from '../api';

const Payout = () => {
  const [isPayoutModalOpen, setIsPayoutModalOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isCantEditModal, setIsCantEditModal ] = useState(false);

  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.app);
  const { businessConfig = {},  eventsCount } = useSelector((state) => state.eventList);
  const { live: liveEvents } = eventsCount || {};

  useEffect(() => {
    if (userData?.business_config_id
      && (businessConfig?.business_config_id !== userData.business_config_id)
    ) getBusinessConfig(userData.business_config_id);
  }, [userData?.business_config_id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleAddPayout = () => {
    setIsPayoutModalOpen(true);
  }
  const handleEditPayout = () => {
    if(liveEvents?.length){
      setIsCantEditModal(true);
    }else{
      setIsPayoutModalOpen(true);
    }
  }
  const handleSavePayout = (details) => {
    const payload = {
      ...businessConfig,
      payment_details: {
        ...businessConfig?.payment_details,
        ...details,
        user_id: userData?.smp_user_id,
        business_config_id: Number(userData?.business_config_id),
        id: businessConfig?.payment_details?.id || 0,
      },
    };
    updateBusinessConfig(userData?.business_config_id, payload, 'EVENT_LIST', () => {
      window.fbq("track", "AddPaymentInfo");
      setIsPayoutModalOpen(false);
      notify('success', 'Payout details updated successfully!');
    });
  }
  const handleCloseModal = () => {
    setIsPayoutModalOpen(false);
  }
  const handleCloseCantEditModal=() =>{
    setIsCantEditModal(false);
  }
  return (
    <div>
      <div className=' pb-4 flex justify-between payout-title'>
        <div className='heading-24'> Payout details </div>
        {businessConfig?.payment_details?.bank_name && (
          <Button
            onClick={handleEditPayout}
            children='Edit Payout'
            type='secondary'
          /> 
        )}  
      </div>
      {!userData?.business_config_id ? (
        <Banner
          icon={<Calendar size={32}/>}
          title='Create an event to add details'
          cta='List your event'
          ctaIcon={<Plus size={24}/>}
          ctaType='primary-black'
          onClick={() => navigate('../event/create', { state: { from: window.location.pathname } })}
        />
      ) : !businessConfig?.payment_details?.bank_name ? (
        <Banner
          icon={<MoneyWavy size={32}/>}
          title='Add your payout details to get paid'
          cta='Add payout'
          ctaIcon={<Plus size={24}/>}
          ctaType='primary-black'
          onClick={handleAddPayout}
        />
      ) : (
        <div className='grid grid-rows-2 grid-flow-col gap-y-8'>
          <Label title='Account Holder Name'
            content={businessConfig?.payment_details?.account_holder_name}
          />
          <Label title='Account Number'
            content={businessConfig?.payment_details?.account_number}
          />
          <Label title='IFSC Code'
            content={businessConfig?.payment_details?.ifsc_code}
          />
          <Label title='Bank Name'
            content={businessConfig?.payment_details?.bank_name}
          />
        </div>
      )}
      <PayoutModal
        isOpen={isPayoutModalOpen}
        onClose={handleCloseModal}
        onSave={handleSavePayout}
        payout={businessConfig?.payment_details}
        setHasUnsavedChanges={setHasUnsavedChanges}
      />
      <CantEdit
        isOpen={isCantEditModal}
        onConfirm={handleCloseCantEditModal}
      />
      <hr className='w-full my-12 border-y-grey-5 '/>
      <Faq/>
    </div>
  )
}

export default Payout
